(function () {
  function openDrawer() {
    var el = document.getElementById('CartDrawer');
    if (el) el.classList.add('is-open');
    document.documentElement.classList.add('cart-drawer-open');
  }
  function closeDrawer() {
    var el = document.getElementById('CartDrawer');
    if (el) el.classList.remove('is-open');
    document.documentElement.classList.remove('cart-drawer-open');
  }

  function wireDrawerEvents() {
    document.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closeDrawer();
      });
    });
    document.querySelectorAll('[data-qty-decrease]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var stepper = btn.closest('.qty-stepper');
        var serverQty = parseInt(stepper.dataset.serverQty, 10) || 1;
        var newServerQty = Math.max(1, serverQty - 1);
        changeLine(btn.dataset.line, newServerQty);
      });
    });
    document.querySelectorAll('[data-qty-increase]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var stepper = btn.closest('.qty-stepper');
        var serverQty = parseInt(stepper.dataset.serverQty, 10) || 1;
        var newServerQty = serverQty + 1;
        changeLine(btn.dataset.line, newServerQty);
      });
    });
    document.querySelectorAll('[data-qty-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var stepper = input.closest('.qty-stepper');
        var unitsPerVariant = parseInt(stepper.dataset.unitsPerVariant, 10) || 1;
        var displayQty = Math.max(0, parseInt(input.value, 10) || 0);
        var newServerQty = Math.max(0, Math.round(displayQty / unitsPerVariant));
        changeLine(input.dataset.line, newServerQty);
      });
    });
    document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeLine(btn.dataset.line, 0);
      });
    });
    document.querySelectorAll('[data-ajax-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        addItem(btn.dataset.variantId, 1);
      });
    });
    var bumpTrack = document.querySelector('[data-bump-track]');
    if (bumpTrack) {
      var prevBtn = document.querySelector('[data-bump-prev]');
      var nextBtn = document.querySelector('[data-bump-next]');
      var card = bumpTrack.querySelector('.bump-card');
      var step = card ? card.getBoundingClientRect().width + 12 : 160;
      if (prevBtn) prevBtn.addEventListener('click', function () { bumpTrack.scrollBy({ left: -step, behavior: 'smooth' }); });
      if (nextBtn) nextBtn.addEventListener('click', function () { bumpTrack.scrollBy({ left: step, behavior: 'smooth' }); });
    }
  }

  function refreshDrawer(openAfter) {
    return fetch(window.themeRoutes.cart_url + '?section_id=cart-drawer')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newDrawer = doc.getElementById('CartDrawer');
        var oldDrawer = document.getElementById('CartDrawer');
        if (newDrawer && oldDrawer) {
          var wasOpen = oldDrawer.classList.contains('is-open');
          oldDrawer.replaceWith(newDrawer);
          if (openAfter || wasOpen) newDrawer.classList.add('is-open');
          wireDrawerEvents();
        }
        updateCartCount();
      })
      .catch(function (err) { console.error('Erro ao atualizar o carrinho', err); });
  }

  function updateCartCount() {
    fetch(window.themeRoutes.cart_url + '.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      });
  }

  function addItem(variantId, quantity) {
    fetch(window.themeRoutes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function () { refreshDrawer(true); })
      .catch(function (err) { console.error('Erro ao adicionar ao carrinho', err); });
  }

  function changeLine(line, quantity) {
    fetch(window.themeRoutes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function () { refreshDrawer(true); })
      .catch(function (err) { console.error('Erro ao atualizar o carrinho', err); });
  }

  // Para outras seções (ex.: vitrine da home) abrirem o carrinho atualizado
  // depois de adicionar um item. Elas NÃO devem usar [data-ajax-add]: esse
  // atributo é religado a cada atualização do carrinho e, fora do drawer,
  // acumularia um listener novo por clique (1 clique = vários itens).
  window.GNXCart = {
    open: openDrawer,
    close: closeDrawer,
    refresh: refreshDrawer
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-cart-icon]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    });

    // Se a pessoa cair na página /cart (ex: link "voltar ao carrinho" do
    // checkout, um favorito salvo, etc.), abre o drawer automaticamente
    // por cima dela — assim a experiência de carrinho é sempre em painel lateral.
    if (window.themeRoutes && window.location.pathname === window.themeRoutes.cart_url) {
      openDrawer();
    }

    document.querySelectorAll('.buybox-form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;
        var formData = new FormData(form);
        fetch(window.themeRoutes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (submitBtn) submitBtn.disabled = false;
            if (data.status) {
              alert(data.description || 'Não foi possível adicionar ao carrinho.');
              return;
            }
            refreshDrawer(true);
          })
          .catch(function (err) {
            if (submitBtn) submitBtn.disabled = false;
            console.error('Erro ao adicionar ao carrinho', err);
          });
      });
    });

    wireDrawerEvents();
  });
})();
